import { createPropertySelectors } from '@ngxs/store';

import type { AprilMadnessEventModel } from './april-madness-event.model';
import { AprilMadnessEventState } from './april-madness-event.state';

export class AprilMadnessEventSelectors {
  static getSlices = createPropertySelectors<AprilMadnessEventModel>(AprilMadnessEventState);
}
